"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiAccordionDetails = void 0;
var typography_1 = require("../../../theme/global/typography");
var palette_1 = require("../../../theme/global/palette");
exports.MuiAccordionDetails = {
    root: __assign(__assign({ color: palette_1.palette.grey[800] }, typography_1.typography.body2), { padding: '4px 20px 16px' }),
};
